import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Card, Row, Col, Table } from 'react-bootstrap';

function Earnings() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/payments/earnings')
      .then(res => setSummary(res.data))
      .catch(() => setError('Failed to load earnings'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading earnings...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container py-4">
      <h2 className="mb-4">Earnings Summary</h2>
      <Row className="mb-4">
        <Col md={4}>
          <Card className="mb-3 shadow-sm">
            <Card.Body>
              <Card.Title>Total Earnings</Card.Title>
              <h3 className="text-success">${summary?.total || 0}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-3 shadow-sm">
            <Card.Body>
              <Card.Title>Total Payments</Card.Title>
              <h3 className="text-primary">{summary?.count || 0}</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <h4 className="mt-4 mb-3">Monthly Breakdown</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Month</th>
            <th>Total</th>
            <th>Payments</th>
          </tr>
        </thead>
        <tbody>
          {summary?.byMonth?.map((m, i) => (
            <tr key={i}>
              <td>{m.month}</td>
              <td>${m.total}</td>
              <td>{m.count}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default Earnings;
